// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2PWeb","subheader":"ReorderModal_subheader__1bt18","listWrap":"ReorderModal_listWrap__2U9z7"};